<header class="plc-raising-panel__header">
	<div></div>
	<plc-label [title]="title" [size]="'xl'" />
	<plc-icon [name]="'cross'" [hover]="true" (click)="close($event)" />
</header>

<main class="plc-raising-panel__main">
	<ng-content></ng-content>
</main>
